"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminPlayerContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("../payment/models");
const utils_1 = require("../utils");
const models_2 = require("./models");
const c = (0, core_1.initContract)();
exports.adminPlayerContract = c.router({
    playerSearch: {
        method: 'GET',
        path: '/search/',
        query: zod_1.z.object({
            searchTerm: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                players: zod_1.z.array(zod_1.z.object({
                    player: models_2.ZPlayerSelectPrivate,
                    bestMatch: zod_1.z.number(),
                    exactMatch: zod_1.z.boolean(),
                })),
            }),
            404: c.type(),
        },
        summary: 'Admin get player details contract',
    },
    getPlayerById: {
        method: 'GET',
        path: '/details/',
        query: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                player: models_2.ZPlayerSelectPrivate,
                balances: models_1.ZPlayerAccountSelectPrivate,
                lifetimeBillings: zod_1.z.object({
                    totalPayments: zod_1.z.number(),
                    totalSpentToken: zod_1.z.number(),
                    totalSpentGiftCard: zod_1.z.number(),
                    totalSpentPromo: zod_1.z.number(),
                }),
                recentPayments: zod_1.z.array(zod_1.z.object({
                    created_at: zod_1.z.preprocess((val) => (typeof val === 'string' ? new Date(val) : val), zod_1.z.date()),
                    psp_reference: zod_1.z.string(),
                    card_summary: zod_1.z.string().nullable(),
                    card_added_brand: zod_1.z.string().nullable(),
                })),
                spendingUsageThisMonth: zod_1.z.number(),
                recentSpendingByMonth: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
                hasSubscription: zod_1.z.boolean(),
            }),
            404: c.type(),
        },
        summary: 'Admin get player details contract',
    },
    updatePlayerEmail: {
        method: 'POST',
        path: '/:player_id/update-email/',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            emailAddress: zod_1.z.string().email('Invalid email address'),
        }),
        responses: {
            200: zod_1.z.object({
                player: models_2.ZPlayerSelectPrivate,
            }),
            400: c.type(),
            404: c.type(),
        },
        summary: 'Admin update player email',
    },
    updatePlayerSocialLogins: {
        method: 'POST',
        path: '/:player_id/update-social-logins/',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            facebookUserId: zod_1.z.string().optional(),
            googleUserId: zod_1.z.string().optional(),
            appleUserId: zod_1.z.string().optional(),
        }),
        responses: {
            200: zod_1.z.object({
                player: models_2.ZPlayerSelectPrivate,
            }),
            400: c.type(),
            404: c.type(),
        },
        summary: 'Admin update player socials',
    },
    closePlayerAccount: {
        method: 'POST',
        path: '/:player_id/close',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            reason: zod_1.z.string().optional(),
            silent: zod_1.z.boolean().optional(),
        }),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    unfreezePlayerAccount: {
        method: 'POST',
        path: '/:player_id/unfreeze',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({}),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    deletePlayerAccount: {
        method: 'POST',
        path: '/:player_id/delete',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            reason: zod_1.z.string().optional(),
        }),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    disableEmailsForPlayer: {
        method: 'POST',
        path: '/:player_id/disable-emails',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            reason: zod_1.z.string().optional(),
        }),
        responses: {
            200: utils_1.successSchema,
        },
    },
    updatePlayerSpendLimit: {
        method: 'POST',
        path: '/:player_id/update-spend-limit/',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            spendLimitPence: zod_1.z.number().int().nonnegative().nullable(),
        }),
        responses: {
            200: zod_1.z.object({
                player: models_2.ZPlayerSelectPrivate,
            }),
            400: c.type(),
            404: c.type(),
        },
        summary: 'Admin update player spend limit',
    },
}, {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
});
//# sourceMappingURL=player.admin.contract.js.map